export default "__VITE_ASSET__CNQRfG4j__"